<template>
    <div class="user-avatar" :class="{ profile: isProfileAvatar }">
		<div class="avatar-wrapper" :style="{ background: avatarColor }">
			<avatar :username="userName" :backgroundColor="avatarColor" v-if="!userIcon"></avatar>
			<div class="user-icon" v-else>
				<img :src="userIcon"/>
			</div>
		</div>
        <span class="user-name">{{ userName }}</span>
    </div>
</template>

<script>

import Avatar from 'vue-avatar';

export default {
  props: {
    // flag that checks if this is profile avatar. if true, changes style with size for profile avatar
    isProfileAvatar: {
      type: Boolean,
      default: false
    },
    // display name for user
    userName: {
      type: String,
      default: ''
    },
    // path for user icon
    userIcon: {
      type: String,
      default: ''
    },
	// avatar's background color
	avatarColor: {
	  type: String,
      default: null
	}
  },
  components: {
    Avatar
  }
}

</script>

<style lang="scss" scoped>

@import './variables';

.user-avatar {
  display: flex;
  align-items: center;
  pointer-events: none;

  .avatar-wrapper {
	display: flex;
	align-items: center;
	width: $avatar-width-large;
	height: $avatar-height-large;
	border-radius: 50%;;
  }
  .vue-avatar--wrapper {
	width: $avatar-width-large !important;
	height: $avatar-height-large !important;
  }

  .user-icon {
    width: $avatar-icon-width-large;
    height: $avatar-icon-height-large;
	margin: 0 auto;
    border-radius: 50%;
    overflow: hidden;
    pointer-events: none;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .user-name {
    margin-left: $avatar-margin-left-large;
    font-family: $title-font;
    font-weight: 700;
	font-size: $avatar-font-size-large;
	color: $title-dark-grey;
  }

  &.profile {
	.avatar-wrapper {
	  width: $avatar-width-small;
	  height: $avatar-height-small;
	}
    .vue-avatar--wrapper {
      background: white !important;
      width: $avatar-width-small !important;
      height: $avatar-height-small !important;
      font-size: $avatar-font-size-small !important;
      font-weight: bold !important;
      color: $avatar-color-grey !important;
      overflow: hidden;
    }
    .user-icon {
      width: $avatar-icon-width-small;
      height: $avatar-icon-height-small;
    }
    .user-name {
      margin-left: $avatar-margin-left-small;
      font-family: $font;
      font-style: normal;
      font-weight: normal;
      font-size: $avatar-font-size-small;
      line-height: 1;
    }
  }
}

</style>